import { createClient } from 'contentful'
import config from '@src/config'

const space = config.contentfulSpaceId
const accessToken = config.contentfulAccessToken
const host = config.contentfulHost

const client = createClient({
  space,
  accessToken,
  host,
})

const prodEnv = config.appEnvironment === 'production'
const locationType = prodEnv ? 'Production' : 'UAT'

export const getGlobalContent = async () => {
  try {
    // eslint-disable-next-line
    console.log('Location Type', locationType)
    const res = await client.getEntries({
      content_type: 'globalConfig',
      limit: 1,
    })
    const content = res?.items?.[0]?.fields

    if (!content) {
      throw new Error('Failed to fetch global content')
    }
    return content
  } catch (error) {
    throw new Error(error)
  }
}

export const getBrand = async () => {
  try {
    const res = await client.getEntries({
      content_type: 'brand',
      'fields.hostname': window.location.hostname,
      limit: 1,
    })
    const content = res?.items?.[0]?.fields

    if (!content) {
      throw new Error('Failed to fetch brand')
    }
    return content
  } catch (error) {
    throw new Error(error)
  }
}

export const getLocationDetails = async (siteId) => {
  try {
    const res = await client.getEntries({
      content_type: 'restaurant',
      'fields.siteId': siteId,
      limit: 1,
    })
    const location = res?.items?.[0]?.fields

    if (!location) {
      throw new Error('Failed to fetch location')
    }
    return location
  } catch (error) {
    throw new Error(error)
  }
}

export const getLocationFromSlug = async (slug) => {
  try {
    const res = await client.getEntries({
      content_type: 'restaurant',
      'fields.slug': slug,
      limit: 1,
    })
    const location = res?.items?.[0]?.fields

    if (!location) {
      throw new Error('Failed to fetch location')
    }
    return location
  } catch (error) {
    throw new Error(error)
  }
}

export const getNearestLocations = async (coords) => {
  const lat = coords.lat
  const lng = coords.lng

  try {
    const res = await client.getEntries({
      content_type: 'restaurant',
      'fields.location[near]': `${lat},${lng}`,
      'fields.enabled': true,
      'fields.slug[exists]': true,
      limit: 4,
    })
    const brand = await getBrand()
    const items = res?.items ?? []
    const brandLocations = brand?.venues?.map((location) => location?.sys?.id)
    const locations = items
      .filter((location) => brandLocations?.includes(location?.sys?.id))
      .map((location) => location?.fields)

    if (!locations?.[0]) {
      throw new Error('Failed to fetch locations')
    }
    return locations
  } catch (error) {
    throw new Error(error)
  }
}

export const getAllLocations = async () => {
  try {
    const res = await client.getEntries({
      content_type: 'restaurant',
      'fields.enabled': true,
      'fields.slug[exists]': true,
    })
    const brand = await getBrand()
    const items = res?.items ?? []
    const brandLocations = brand?.venues?.map((location) => location?.sys?.id)
    const locations = items
      .filter((location) => brandLocations?.includes(location?.sys?.id))
      .map((location) => location?.fields)

    if (!locations?.[0]) {
      throw new Error('Failed to fetch locations')
    }
    return locations
  } catch (error) {
    throw new Error(error)
  }
}
